<div class="flex flex-col w-full gap-2">
  <sd-clarity-file-browser-breadcrumb
    [breadcrumbs]="breadcrumbs()"
    [disabled]="disabled()"
    (onBreadcrumbClick)="breadcrumbClick($event)"
  ></sd-clarity-file-browser-breadcrumb>

  <sd-clarity-file-browser-table
    [treeItems]="treeItems()"
    [lastSelected]="lastSelected()"
    [showPrevious]="showPrevious()"
    [disabled]="disabled()"
    (onPreviousClick)="previousClick()"
    (onFolderClick)="folderClick($event)"
    (onSelectionChange)="onSelectionChange.emit($event)"
    class="block flex-1 overflow-y-auto"
  ></sd-clarity-file-browser-table>
</div>
